import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import SettingsDrawer from "./SettingsDrawer";
import CartDrawer from "./CartDrawer";
import Background from "./Background";
import GlassCursor from "./GlassCursor";
import Footer from "./Footer";
import { Toaster } from "../components/ui/sonner";

export default function Layout() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const location = useLocation();

  const aurora = location.pathname.startsWith("/shop") || location.pathname.startsWith("/about");

  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  // Backwards-compat: ensure .mt-enter elements end visible
  useEffect(() => {
    const t = window.setTimeout(() => {
      document.querySelectorAll(".mt-enter").forEach((el) => el.classList.add("mt-in"));
    }, 1100);
    return () => window.clearTimeout(t);
  }, [location.pathname]);

  return (
    <div className="App relative">
      <Background variant={location.pathname} aurora={aurora} />
      <GlassCursor />
      <Navbar onOpenSettings={() => setSettingsOpen(true)} />
      <SettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
      <CartDrawer />
      <main className="relative" style={{ paddingTop: "var(--nav-h)" }}>
        <Outlet />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}
